import { Component, OnInit, ViewChild, ElementRef, Renderer2 } from '@angular/core';
import { NgxPermissionsService } from 'ngx-permissions';
import { MatSnackBar, MatSidenav } from '@angular/material';
import * as moment from 'moment';
import { Router, NavigationEnd } from '@angular/router';
import { Tarea, TareaTipo } from '../../interfaces/tarea';
import { PermisoService } from '../../providers/permiso.service';
import { TareaService } from '../../providers/tarea.service';
import { Cotizacion } from '../../interfaces/cotizacion';
import { Usuario } from '../../interfaces/usuario';
import { TareaResponsable } from '../../forms/tareas/tarea-responsables/tarea-responsable/tarea-responsable';
import { Notificacion } from '../../interfaces/notificacion';
import { NotificacionService } from '../../providers/notificacion.service';
import { ConfiguracionEmpresaService } from '../../providers/configuracion-empresa.service';
import { Subject } from 'rxjs';
@Component({
  selector: 'app-logueado',
  templateUrl: './logueado.component.html',
  styleUrls: ['./logueado.component.scss']
})
export class LogueadoComponent implements OnInit {
  buscarNotificaciones: any;
  tareas: Tarea[] = <Tarea[]>[];
  notificaciones: Notificacion[] = <Notificacion[]>[];
  SEGUNDOS_POLLING_NOTIFICACIONES = 50; // cada cuantos segundos buscar notificaciones pendientes

  @ViewChild('calendarioSidenav') calendarioSidenav: MatSidenav;
  @ViewChild('container', { read: ElementRef }) private container: ElementRef;
  contadoresBadge: any;

  constructor(
    private permissionsService: NgxPermissionsService,
    private permisoService: PermisoService,
    private tareaService: TareaService,
    private notificacionService: NotificacionService,
    public snackBar: MatSnackBar,
    private router: Router,
    private renderer: Renderer2,
    private _confSv: ConfiguracionEmpresaService
  ) {
    // al navegar sobre pantallas
    this.router.events
      .filter(event => event instanceof NavigationEnd)
      .subscribe((event: NavigationEnd) => {
        // cerrar el menú derecho
        if (this.calendarioSidenav) {
          this.calendarioSidenav.close();
        }
      });
    // this.notificacionService.configuracion.subscribe(r => {
    //   console.log(r, "datos")
    // });
  }
  // configuracion = new Subject<any>();

  ngOnInit(): void {
    this.permisoService.getPermisos().subscribe(permisos => { // traer permisos del servidor
      this.permissionsService.loadPermissions(permisos); // asignarlos a la libreria que los adminsitra
    });
    this.checkTareasPendientesLoop();
  }

  /**
   * Cuando el sidenavo del calendario cambia de estado
   */
  clrioOpenedChange(event: any): void {
    // si el menu fue cerrado
    if (event == false) {
      // arreglar un bug de material en el que no quita esta clase
      if (this.container) {
        this.removeClass(this.container.nativeElement, 'mat-drawer-transition');
      }
    }
  }

  removeClass(nativeElement: any, className: string) {
    this.renderer.removeClass(nativeElement, className);
  }

  checkTareasPendientesLoop(): void {
    // Checkear si hay notificaciones loop

    setTimeout(() => {
      this.buscarNotificacionesPendientes();
    }, 4750);

    this.buscarNotificaciones = setInterval(() => {
      this.buscarNotificacionesPendientes();
    }, this.SEGUNDOS_POLLING_NOTIFICACIONES * 1000);
  }

  buscarNotificacionesPendientes(): void {
    // notificaciones de: TAREAS
    this.tareaService.notificar().subscribe(
      respuesta => {
        if (respuesta.estado == 1) {
          if (respuesta.data && respuesta.data.notificadas) {
            this.tareas = <Tarea[]>[];
            respuesta.data.notificadas.forEach((tarea) => {
              this.tareas.push(
                new Tarea(
                  tarea.IdTarea,
                  tarea.titulo,
                  tarea.fechaTarea,
                  tarea.fechaTarea ? moment(tarea.fechaTarea).format('HH:mm:ss') : null,
                  tarea.fechaNotificacion,
                  tarea.fechaNotificacion ? moment(tarea.fechaNotificacion).format('HH:mm:ss') : null,
                  tarea.descripcion,
                  tarea.cantidadResponsables,
                  tarea.totalCompletadasResponsables,
                  new Cotizacion(
                    tarea.cotizacion.IdCotizacion
                  ),
                  new TareaTipo(
                    tarea.tipo.id,
                    tarea.tipo.descripcion
                  ),
                  (tarea.soyResponsable) ? new TareaResponsable(
                    tarea.soyResponsable.IdTareaResponsable,
                    new Usuario(
                      tarea.soyResponsable.usuario.IdUsuario,
                      tarea.soyResponsable.usuario.usuario,
                      null,
                      null,
                      null,
                      tarea.soyResponsable.usuario.nombre,
                      tarea.soyResponsable.usuario.apellido
                    ),
                    tarea.soyResponsable.fechaCompletada
                  ) : null
                )
              );
            });
          }
        }
      }
    );

    // notificaciones generales
    this.notificacionService.getNotificaciones().subscribe(
      respuesta => {
        if (respuesta.estado == 1) {
          if (respuesta.data && respuesta.data.notificadas) {
            this.notificaciones = <Notificacion[]>[];
            respuesta.data.notificadas.forEach((notificacion) => {
              this.notificaciones.push(
                new Notificacion(
                  (+notificacion.id),
                  notificacion.titulo,
                  notificacion.descripcion,
                  notificacion.data
                )
              );
            });
          }
        }
      }
    );
  }

  ngOnDestroy(): void {
    // al desloguearse dejar de buscar notificaciones
    clearInterval(this.buscarNotificaciones);
  }
}
